import sessionStorage from 'sessionstorage';

/**
 * validateEmail
 * @param {String} email - Email string to check validity of
 * @returns boolean
 */
export const validateEmail = (email) => {
	const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	if (email.match(EMAIL_REGEX) == null) {
		return false;
	}
	return true;
};

/**
 * validatePostal
 * @param {String} zip - Postal code string to check validity of
 * @returns boolean
 */
export const validatePostal = (postalCode) => {
	const usZipRegex = /^(\d{5}(\-\d{4})?)$/;
	const caZipRegex = /^\D\d\D(\-| |)?\d\D\d$/i;

	if (postalCode.match(usZipRegex) === null && postalCode.match(caZipRegex) === null) {
		return false;
	}
	return true;
};

/**
 * getSessionStorage
 * @param {String} key - Key to fetch from session storage
 * @returns original value format (string, object, array, etc.)
 */
export const getSessionStorage = (key) => {
	if (storageAvailable('sessionStorage')) {
		try {
			let value = sessionStorage.getItem(key);

			// ensure object if supposed to be
			if (typeof value === 'string' && ((value.startsWith('{') && value.endsWith('}')) || (value.startsWith('[') && value.endsWith(']')))) {
				try {
					value = JSON.parse(value);
				} catch {}
			}

			return value;
		} catch (error) {
			return null;
		}
	} else {
		return null;
	}
};

/**
 * setSessionStorage
 * @param {String} key - Key to set in session storage
 * @param {Any} value - Value to set in session storage
 * @param {Boolean} stringify - Whether or not to stringify the value
 */
export const setSessionStorage = (key, value, stringify = true) => {
	if (storageAvailable('sessionStorage')) {
		try {
			sessionStorage.setItem(key, stringify ? JSON.stringify(value) : value);
		} catch (error) {
			return false;
		}
	} else {
		return false;
	}
};

/**
 * removeSessionStorage
 * @param {String} key - Key to remove from session storage
 */
export const removeSessionStorage = (key) => {
	if (storageAvailable('sessionStorage')) {
		try {
			return sessionStorage.removeItem(key);
		} catch (error) {
			return null;
		}
	} else {
		return null;
	}
};

/**
 * storageAvailable
 * @param {String} type - Type of storage to check availability of
 * @returns boolean
 */
export const storageAvailable = (type) => {
	// accepts sessionstorage or localstorage
	// https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#feature-detecting_localstorage

	if (typeof window !== 'undefined') {
		var storage;
		try {
			storage = window[type];
			var x = '__storage_test__';
			storage.setItem(x, x);
			storage.removeItem(x);
			return true;
		} catch (e) {
			return (
				e instanceof DOMException &&
				// everything except Firefox
				(e.code === 22 ||
					// Firefox
					e.code === 1014 ||
					// test name field too, because code might not be present
					// everything except Firefox
					e.name === 'QuotaExceededError' ||
					// Firefox
					e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
				// acknowledge QuotaExceededError only if there's something already stored
				storage &&
				storage.length !== 0
			);
		}
	}
};
